module.exports = __webpack_public_path__ + "fonts/Inter-700-greek67.4a4b49c.woff2";